/**
 * Generate a simple random ID.
 */
export function randomID(): string {
  return Math.random().toString(16).slice(2)
}
